import { useEffect, useState } from 'react';
import { Img } from 'react-image';

interface Props {
	topMargin?: number;
}

export const TopTierCompanies = ({ topMargin = 0 }: Props) => {
	const theme = 'dark';
	const [isMobileScreen, setIsMobileScreen] = useState<boolean>(false);
	useEffect(() => {
		const isMobileScreen = window.innerWidth <= 960;
		setIsMobileScreen(isMobileScreen);
	}, []);
	return (
		<div className={`flex flex-col gap-[8px] mt-[${topMargin}px]`}>
			<div
				className={`text-sm font-medium ${
					theme === 'dark' ? 'topTiercompanie_dark_theme' : 'topTiercompanie_light_theme'
				}`}
			>
				Our experts are tech professionals {isMobileScreen ? '' : 'working '} at
			</div>
			<div className="flex items-center gap-[10px]">
				<Img src="/assets/topTierCompanies.svg" alt="topTierCompanies" width={192} height={32} />
				<div
					className={`text-xs font-normal ${
						theme === 'dark' ? 'otherTopComapnies_text_dark_theme' : 'otherTopComapnies_text_light_theme'
					}`}
				>
					and other top tier companies
				</div>
			</div>
		</div>
	);
};
